'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_types$UserCode$() {
  this.cdp = null;
  this.cdq = false;
  this.cdn = null;
  this.cdo = false;
}
export { $c_Lpresto_types$UserCode$ as $c_Lpresto_types$UserCode$ };
$p = $c_Lpresto_types$UserCode$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$UserCode$;
/** @constructor */
function $h_Lpresto_types$UserCode$() {
}
export { $h_Lpresto_types$UserCode$ as $h_Lpresto_types$UserCode$ };
$h_Lpresto_types$UserCode$.prototype = $p;
$p.a2F = (function() {
  if ((!this.cdq)) {
    this.cdp = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Encoder$().aD;
    this.cdq = true;
  }
  return this.cdp;
});
$p.r3 = (function() {
  if ((!this.cdo)) {
    this.cdn = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().aa;
    this.cdo = true;
  }
  return this.cdn;
});
var $d_Lpresto_types$UserCode$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$UserCode$, "presto.types$UserCode$", ({
  a2B: 1,
  D: 1
}));
export { $d_Lpresto_types$UserCode$ as $d_Lpresto_types$UserCode$ };
var $n_Lpresto_types$UserCode$;
function $m_Lpresto_types$UserCode$() {
  if ((!$n_Lpresto_types$UserCode$)) {
    $n_Lpresto_types$UserCode$ = new $c_Lpresto_types$UserCode$();
  }
  return $n_Lpresto_types$UserCode$;
}
export { $m_Lpresto_types$UserCode$ as $m_Lpresto_types$UserCode$ };
//# sourceMappingURL=presto.types$-User-Code$.js.map
